// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-4d712c08] {\n  --magic-element-default-width: 344px;\n  --magic-deposit-limit-dialog-offset: var(--magic-offset-top, 56px);\n}\n.modal.modal--small[data-v-4d712c08] {\n  padding: var(--magic-space--small, 8px);\n}\n.modal .body.body--small[data-v-4d712c08] {\n  margin: var(--magic-space--small, 8px) auto var(--magic-space--large, 24px);\n}\n\n.action[data-v-4d712c08] {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
